module.exports = __webpack_public_path__ + "img/bit-coin-line.57839431.svg";